<app-collapsible-section
  title="Basic Info"
  [isExpanded]="isExpanded"
  [isCompleted]="isCompleted"
  [showDoneButton]="true"
  (toggle)="onBasicInfoToggle($event)"
  (done)="onBasicInfoDone()"
>
  <ng-template #sectionContent>
    <div class="form-container">
      <div class="form-group">
        <label for="campaignName">Campaign Name <span class="required">*</span></label>
        <input
          type="text"
          id="campaignName"
          [(ngModel)]="campaignName"
          (ngModelChange)="onCampaignNameChange()"
          (input)="onCampaignNameInput($event)"
          placeholder="e.g. Black Friday Campaign"
          class="form-control"
          maxlength="100"
          minlength="2"
          [class.error]="
            showCampaignNameError ||
            showCampaignNameMinLengthError ||
            showCampaignNameSpecialCharError ||
            campaignNameConflictError
          "
          required
        />
        @if (showCampaignNameError) {
          <div class="error-message">Campaign name is required</div>
        }
        @if (showCampaignNameMinLengthError) {
          <div class="error-message">Campaign name must be at least 2 characters</div>
        }
        @if (showCampaignNameSpecialCharError) {
          <div class="error-message">
            Only letters, numbers, spaces, and basic punctuation (. , - ' ( ) %) are allowed
          </div>
        }
        @if (campaignNameConflictError && campaignName.trim()) {
          <div class="error-message">
            {{ campaignNameErrorMessage }}
          </div>
        }
      </div>
      <div class="form-group">
        <label for="description">Description <span class="required">*</span></label>
        <input
          type="text"
          id="description"
          [(ngModel)]="description"
          (ngModelChange)="onFormChange()"
          (input)="onDescriptionInput($event)"
          placeholder="e.g. Campaign for 40% Black Friday discount."
          class="form-control"
          minlength="2"
          [class.error]="
            showDescriptionError ||
            showDescriptionMinLengthError ||
            showDescriptionSpecialCharError ||
            showDescriptionLengthError
          "
          required
        />
        @if (showDescriptionError) {
          <div class="error-message">Description is required</div>
        }
        @if (showDescriptionMinLengthError) {
          <div class="error-message">Description must be at least 2 characters</div>
        }
        @if (showDescriptionLengthError) {
          <div class="error-message">Description cannot exceed 300 characters</div>
        }
        @if (showDescriptionSpecialCharError) {
          <div class="error-message">
            Only letters, numbers, spaces, and basic punctuation (. , - ' ( ) %) are allowed
          </div>
        }
      </div>
      <div class="form-footer">
        <button class="btn btn-primary btn-medium" (click)="onBasicInfoDone()">Done</button>
      </div>
    </div>
  </ng-template>
</app-collapsible-section>
